module.exports = __webpack_public_path__ + "/img/bijeli.ad2567a1.png";